export default "__VITE_ASSET__CjIbkImB__"